var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2513 4.83335C15.5648 3.80584 14.635 2.96389 13.5446 2.38235C12.4542 1.80082 11.2371 1.49772 10.0013 1.50001C8.76767 1.49926 7.55294 1.80312 6.46497 2.38461C5.37699 2.96611 4.44943 3.80725 3.76463 4.83335M9.58464 1.50001C8.93517 2.54052 8.42366 3.66101 8.06298 4.83335M10.418 1.50001C11.068 2.54043 11.5801 3.66093 11.9413 4.83335M16.2513 13.1667C15.5648 14.1942 14.635 15.0361 13.5446 15.6177C12.4542 16.1992 11.2371 16.5023 10.0013 16.5C8.76767 16.5008 7.55294 16.1969 6.46497 15.6154C5.37699 15.0339 4.44943 14.1928 3.76463 13.1667M9.58464 16.5C8.93517 15.4595 8.42366 14.339 8.06298 13.1667M10.418 16.5C11.068 15.4596 11.5801 14.3391 11.9413 13.1667M1.66797 7.33335L2.5013 10.6667L3.7513 7.33335L5.0013 10.6667L5.83464 7.33335M14.168 7.33335L15.0013 10.6667L16.2513 7.33335L17.5013 10.6667L18.3346 7.33335M7.91797 7.33335L8.7513 10.6667L10.0013 7.33335L11.2513 10.6667L12.0846 7.33335",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineIcon);
export default __webpack_public_path__ + "static/media/online-icon.df90bf904d451824f68f8730128a370b.svg";
export { ForwardRef as ReactComponent };